import React from "react";
import PropTypes from "prop-types";
import "./LoadingState.scss";

/**
 * LoadingState
 *
 * Standard centred spinner + message for "content is loading" areas (lists,
 * panels, tabs). Use while data is being fetched, before deciding between real
 * content and an EmptyState.
 */
const LoadingState = ({ message = "Loading…", minHeight = 200, className = "" }) => (
  <div className={`loading-state ${className}`} style={{ minHeight }}>
    <div className="loading-state__spinner" />
    {message && <span className="loading-state__message">{message}</span>}
  </div>
);

LoadingState.propTypes = {
  message: PropTypes.string,
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

export default LoadingState;
